import { Table } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { useColumns } from './hooks/useColumns';
import { StudentsRemovalRequestStudent } from '../types/students';
import TableEmptyContent from '../../../../components/text/TableEmptyContent';
import { useStudentsRemovalRequestStudentstList } from './StudentsRemovalRequestStudentsListLoader';

export interface StudentsRemovalRequestStudentsTableProps {
  data: StudentsRemovalRequestStudent[];
  loading: boolean;
  onCreateRequest: (studyPlanEnrollmentId: number) => void;
  onViewDetail: (studyPlanEnrollmentId: number) => void;
}

export function StudentsRemovalRequestStudentsTable({
  data,
  loading,
  onCreateRequest,
  onViewDetail,
}: StudentsRemovalRequestStudentsTableProps) {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_STUDENTS,
  );

  const { query } = useStudentsRemovalRequestStudentstList();

  const texts = useMemo(() => {
    return t<
      string,
      {
        empty: {
          noResults: {
            title: string;
            body: string;
          };
          noSearch: {
            title: string;
            body: string;
          };
        };
      }
    >('students.table', {
      returnObjects: true,
    });
  }, [t]);

  const textsEmpty = useMemo(() => {
    if (!query.studentNameOrId) {
      return texts.empty.noSearch;
    }
    return texts.empty.noResults;
  }, [texts, query]);

  const columns = useColumns({ onCreateRequest, onViewDetail });

  return (
    <Table
      columns={columns}
      data={data}
      isLoadingResults={loading}
      noResultsText={
        <TableEmptyContent
          title={textsEmpty.title}
          subtitle={textsEmpty.body}
        />
      }
    />
  );
}
